<div class="call-main"
role="dialog"
aria-modal="true"
aria-labelledby="callbackDialogTitleMobile">
  <!-- <div class="pop-up-heading">
     <br>Request a Callback
  </div> -->
  <h2
    id="callbackDialogTitleMobile"
    class="pop-up-heading">
    Request a Callback
</h2>
  <div class="pop-up-info">
    Please fill the details below and we will get in touch with you
  </div>
  <form name="form" (ngSubmit)="f.form.valid && processForm()" #f="ngForm" novalidate>
  <div class="col-lg-12 row">

      <div class="col-lg-6">
          <label  class="lbl-text" for="mobileFirstName">First Name <span class="mandatory"> *</span></label><br>
          <input id="mobileFirstName" type="text" [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="firstName" autocomplete="given-name" name="first" #fname="ngModel" required
          [attr.aria-invalid]="f.submitted && fname.invalid"
          aria-describedby="mobileFirstNameError">
          <!-- <div *ngIf="f.submitted && fname.invalid" class="error-text"> -->
            <div
            *ngIf="f.submitted && fname.invalid"
            id="mobileFirstNameError"
            class="error-text"
            role="alert">
            <div *ngIf="fname.errors?.['required']">First name is required</div>
            <div *ngIf="fname.errors?.['pattern']">Name not valid.</div>
          </div>
      </div>
      <div class="col-lg-6">
          <label  class="lbl-text" for="mobileLastName">Last Name <span class="mandatory"> *</span></label><br>
          <input id="mobileLastName" type="text"  [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="lastName" autocomplete="family-name" name="last"   #lname="ngModel" required [attr.aria-invalid]="f.submitted && lname.invalid"
           aria-describedby="mobileLastNameError">
          <div *ngIf="f.submitted && lname.invalid" class="error-text" id="mobileLastNameError"
          role="alert">
            <div *ngIf="lname.errors?.['required']">Last name is required</div>
            <div *ngIf="lname.errors?.['pattern']">Name not valid.</div>
          </div>
      </div>
      <div class="col-lg-6">
          <label  class="lbl-text" for="mobileNumber">Mobile <span class="mandatory"> *</span></label><br>
          <input id="mobileNumber" type="text" [pattern]="mobNumberPattern" [(ngModel)]="userData.mobileNumber" autocomplete="tel" name="mobile"   #mobile="ngModel" required
          [attr.aria-invalid]="f.submitted && mobile.invalid"
          aria-describedby="mobileError" minlength="10" maxid="mobileNumber"length="10">
          <!-- <div class="error-text"> -->
            <div
            id="mobileError"
            class="error-text"
            role="alert">
            <div *ngIf="f.submitted && mobile.errors?.['required']">Mobile number required</div>
            <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
          <label for="mobileEmail" class="lbl-text">Email ID<span class="mandatory"> *</span></label><br>
          <input id="mobileEmail" type="email"  minlength="5" maxlength="64"  [(ngModel)]="userData.emailId" autocomplete="email" name="email"  #email="ngModel" required email [attr.aria-invalid]="f.submitted && email.invalid"
           aria-describedby="mobileEmailError">
          <div *ngIf="f.submitted && email.invalid" class="error-text" id="mobileEmailError"
           role="alert">
            <div *ngIf="email.errors?.['required']">Email required</div>
            <div *ngIf="email.errors?.['email']">Enter a valid email address</div>
          </div>
      </div>
      <div class="col-lg-6">
        <label  for="mobileCity" class="lbl-text">City <span class="mandatory"> *</span></label><br>
        <input id="mobileCity" type="text" [pattern]="alphaPattern" minlength="1" maxlength="32"  [(ngModel)]="userData.city" autocomplete="address-level2" name="city"  #cityname="ngModel" required [attr.aria-invalid]="f.submitted && cityname.invalid"
         aria-describedby="mobileCityError">
        <div *ngIf="f.submitted && cityname.invalid" class="error-text" id="mobileCityError"
         role="alert">
          <div *ngIf="cityname.errors?.['required']">City required</div>
          <div *ngIf="cityname.errors?.['pattern']">City not valid.</div>
        </div>
    </div>

      <div class="col-lg-12">
          <label  for="mobileMessage" class="lbl-text">Message </label><br>
          <mat-label>Message (Maximum 100 characters)</mat-label>
          <textarea id="mobileMessage" rows="1" [pattern]="msgPattern" maxlength="100" name="message" #message="ngModel"  [(ngModel)]="userData.message" [attr.aria-invalid]="f.submitted && message.invalid"
           aria-describedby="mobileMessageError"></textarea>
          <!-- <div *ngIf="f.submitted && message.invalid" class="error-text"> -->
            <div
              *ngIf="f.submitted && message.invalid"
              id="mobileMessageError"
              class="error-text"
              role="alert">
            <div *ngIf="message.errors?.['pattern']">Invalid message.</div>
          </div>
        </div>
      <div class="col-lg-12 text-center">
          <button class="submit-button btn-spc ">Submit</button>
      </div>
  </div>
</form>
<button type="button" class="floating-button content-mobile-section" (click)="investOnline()" >Invest Online</button>

</div>
